import { Form, Button, Col } from 'react-bootstrap';
import OrgnrInput, { BrRegInfo } from 'components/OrgnrInput';
import { OrgNrInfo } from './types';

interface Props {
  outgoing: OrgNrInfo;
  enhetJurNavn: string;
  duplicateWarning: string;
  onChange: (value: OrgNrInfo) => void;
  onAttentionChange?: (needsAttention: boolean) => void; // name mismatch signaled from OrgnrInput
  onSeeEnheter: (criteria: string) => void;
}

const OrgNrRight = ({
  outgoing,
  enhetJurNavn,
  duplicateWarning,
  onChange,
  onAttentionChange,
  onSeeEnheter,
}: Props) => {
  const handleChange = (br?: BrRegInfo) => {
    if (!br) {
      onChange({ juridisknavn: '', organisasjonsnr: '', isOrgnrValidated: false });
      return;
    }
    onChange({ juridisknavn: br.name, organisasjonsnr: br.orgNr, isOrgnrValidated: true });
  };

  return (
    <Col xs={12} md={5}>
      <Form.Group>
        <OrgnrInput
          type="orgnr"
          selected={{ name: outgoing.juridisknavn, orgNr: outgoing.organisasjonsnr }}
          onChange={handleChange}
          size="sm"
          onJuridiskNameMismatch={(mismatch) => onAttentionChange?.(mismatch)}
        />
        {!enhetJurNavn && outgoing?.organisasjonsnr && duplicateWarning && (
          <Form.Text className="text-muted">
            <span>{duplicateWarning} </span>
            <Button
              variant="link"
              size="sm"
              className="p-0 align-baseline"
              onClick={(e) => {
                e.preventDefault();
                onSeeEnheter(outgoing.organisasjonsnr);
              }}
            >
              Se enhet(er)
            </Button>
          </Form.Text>
        )}
      </Form.Group>
    </Col>
  );
};

export default OrgNrRight;
